<template>
	<div class="engine-container">
		<iframe
			v-if="validUrl"
			:src="validUrl"
			frameborder="0"
			class="w-100 h-100"
			allow="clipboard-read; clipboard-write"
		></iframe>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
	import moment from 'moment'

	const ENGINE_URL = process.env.VUE_APP_ENGINE_URL

	export default {
		name: 'Engine',
		data() {
			return {
				validUrl: null,
				session_key: null,
			}
		},
		computed: {
			...mapGetters('auth', ['account']),
			...mapGetters('system', ['keep_connected']),
		},
		methods: {
			...mapActions('auth', ['Logout']),
			async CleanExpiredEngineSessions(skipKey = null) {
				let sessionKeys = JSON.parse(
					localStorage.getItem('engine_session_keys') || '[]'
				)
				let changed = false

				for (const s of [...sessionKeys]) {
					if (skipKey && s.session_key === skipKey) {
						continue
					}

					// const { data } = await window.axios.put(`/api/sessions/${s.session_key}`);

					// if(!data.valid) {
					//     sessionKeys = sessionKeys.filter(sk => sk.session_key !== s.session_key);
					//     changed = true;
					// }
				}

				if (changed) {
					localStorage.setItem(
						'engine_session_keys',
						JSON.stringify(sessionKeys)
					)
				}
			},
			async Login() {
				let sessionKeys = JSON.parse(
					localStorage.getItem('engine_session_keys') || '[]'
				)
				let lastSession = sessionKeys.length
					? sessionKeys[sessionKeys.length - 1]
					: null
				let previous_session_key = lastSession?.session_key ?? null

				return window.engine_api
					.call('post', '/sessions', {
						account_id: this.account.id,
						keep_connected: this.keep_connected.active ?? false,
						previous_session_key,
					})
					.then(response => {
						if (response.status === 201) {
							this.session_key = response.data.session_key
							this.validUrl = `${ENGINE_URL}/login?session=${this.session_key}`
						}
					})
			},
		},
		beforeRouteLeave(to, from, next) {
			const iframe = this.$el.querySelector('iframe')
			if (iframe && iframe.contentWindow) {
				iframe.contentWindow.postMessage({ type: 'iframe-unload' }, '*')
			}
			next()
		},
		beforeMount() {
			this.Login()
		},
		mounted() {
			window.addEventListener('message', async event => {
				if (!event.data?.type) return

				if (
					event.data.type === 'engine-session-key' &&
					event.data.session_key
				) {
					let sessionKeys = JSON.parse(
						localStorage.getItem('engine_session_keys') || '[]'
					)
					const now = moment().format('YYYY-MM-DD HH:mm:ss')

					const idx = sessionKeys.findIndex(
						s => s.session_key === event.data.session_key
					)
					if (idx === -1) {
						sessionKeys.push({
							session_key: event.data.session_key,
							updated_at: now,
						})
					} else {
						sessionKeys[idx].updated_at = now
					}

					localStorage.setItem(
						'engine_session_keys',
						JSON.stringify(sessionKeys)
					)

					await this.CleanExpiredEngineSessions(
						event.data.session_key
					)
				}

				switch (event.data.type) {
					case 'show-notification':
						if (Notification.permission === 'granted') {
							new Notification('Aviso de Inatividade', {
								body: event.data.body,
								icon: event.data.icon,
							})
						} else if (Notification.permission === 'default') {
							Notification.requestPermission().then(
								permission => {
									if (permission === 'granted') {
										new Notification(
											'Aviso de Inatividade',
											{
												body: event.data.body,
												icon: event.data.icon,
											}
										)
									}
								}
							)
						}
						break
					case 'logout-warning':
						if (Notification.permission === 'granted') {
							new Notification('Aviso de Inatividade', {
								body: event.data.body,
								icon: event.data.icon,
							})
						}
						break
					case 'logout':
						if (event.data.source === 'management') return

						if (event.data.session_key) {
							let sessionKeys = JSON.parse(
								localStorage.getItem('engine_session_keys') ||
									'[]'
							)

							sessionKeys = sessionKeys.filter(
								s => s.session_key !== event.data.session_key
							)

							localStorage.setItem(
								'engine_session_keys',
								JSON.stringify(sessionKeys)
							)
						}

						this.Logout({ fromEngine: true })
						break
				}
			})
		},
	}
</script>

<style scoped>
	.engine-container {
		height: calc(100vh - 107px);
		width: 100vw;
	}
</style>
